import { render } from "./FPluginTable.vue?vue&type=template&id=165497e7&scoped=true"
import script from "./FPluginTable.vue?vue&type=script&lang=js"
export * from "./FPluginTable.vue?vue&type=script&lang=js"

import "./FPluginTable.vue?vue&type=style&index=0&id=165497e7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165497e7"]])

export default __exports__